var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTriangleUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29284 8.2072C9.68337 7.81668 10.3165 7.81668 10.7071 8.2072L15.1464 12.6465C15.4614 12.9615 15.2383 13.5001 14.7928 13.5001L5.20706 13.5001C4.7616 13.5001 4.53852 12.9615 4.8535 12.6465L9.29284 8.2072Z",
    fill: "#47494D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTriangleUp);
export default __webpack_public_path__ + "static/media/icon-triangle-up.91bb9ebcdbdb5e233a8f42c2eb023e0c.svg";
export { ForwardRef as ReactComponent };